<template>
  <b-form-group :label="label" label-for="date-range">
    <date-range-picker
      ref="picker"
      v-model="dateRangeCopy"
      :locale-data="{ firstDay: 1, format: config.dateTimeFormat }"
      :ranges="dateRanges"
      linked-calendars
      class="picker"
      time-picker
      @update="onDateRangeUpdate"
    >
      <div slot="input" slot-scope="picker">
        {{ picker.startDate | date }} - {{ picker.endDate | date }}
      </div>
    </date-range-picker>
  </b-form-group>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import { config } from '@/config'

export default {
  name: 'DateRange',
  components: { DateRangePicker },
  props: {
    label: {
      type: String,
      default: 'Date range',
    },
    dateRange: {
      type: Object,
      required: true,
    },
    dateRanges: {
      type: Object,
      default: () => ({
        Today: [moment().startOf('day'), moment()],
        Yesterday: [
          moment()
            .subtract(1, 'days')
            .startOf('day'),
          moment()
            .subtract(1, 'days')
            .endOf('day'),
        ],
        'Last 7 days': [
          moment()
            .subtract(7, 'days')
            .startOf('day'),
          moment(),
        ],
        'Last 30 days': [
          moment()
            .subtract(1, 'month')
            .startOf('day'),
          moment(),
        ],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'Last month': [
          moment()
            .subtract(1, 'month')
            .startOf('month'),
          moment()
            .subtract(1, 'month')
            .endOf('month'),
        ],
      }),
    },
  },
  data() {
    return {
      dateRangeCopy: {},
      config,
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(newDateRange) {
        this.dateRangeCopy = newDateRange
      },
    },
  },
  methods: {
    onDateRangeUpdate(dateRange) {
      let { startDate, endDate } = dateRange
      const payload = { startDate, endDate }
      startDate = moment(startDate)
      endDate = moment(endDate)
      this.$emit('dateUpdate', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.picker {
  width: 100%;
}
</style>
